import React from 'react';
import { Link } from 'react-router-dom';
import { FleurDeLysIcon } from './Icons';

export const Footer = () => {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '2rem 1rem 1.5rem',
      marginTop: 'auto',
      gap: '1rem'
    }}>
      {/* Legal Links */}
      <div style={{
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
        gap: '0.5rem 1rem',
        fontSize: '0.85rem',
        maxWidth: '100%',
        textAlign: 'center'
      }}>
        <Link 
          to="/faq"
          style={{
            color: '#87A96B',
            textDecoration: 'none',
            fontWeight: '600',
            transition: 'color 0.2s ease',
          }}
          onMouseEnter={(e) => e.currentTarget.style.color = '#6B8A54'}
          onMouseLeave={(e) => e.currentTarget.style.color = '#87A96B'}
        >
          FAQ
        </Link>
        <span style={{ color: '#D4D4C0' }}>•</span>
        <Link 
          to="/legal/terms"
          style={{
            color: '#6B7B6E',
            textDecoration: 'none',
            transition: 'color 0.2s ease',
          }}
          onMouseEnter={(e) => e.currentTarget.style.color = '#87A96B'}
          onMouseLeave={(e) => e.currentTarget.style.color = '#6B7B6E'}
        >
          Conditions d'utilisation
        </Link>
        <span style={{ color: '#D4D4C0' }}>•</span>
        <Link 
          to="/legal/privacy"
          style={{
            color: '#6B7B6E',
            textDecoration: 'none',
            transition: 'color 0.2s ease',
          }}
          onMouseEnter={(e) => e.currentTarget.style.color = '#87A96B'}
          onMouseLeave={(e) => e.currentTarget.style.color = '#6B7B6E'}
        >
          Politique de confidentialité
        </Link>
        <span style={{ color: '#D4D4C0' }}>•</span>
        <Link 
          to="/legal/copyright"
          style={{
            color: '#6B7B6E',
            textDecoration: 'none',
            transition: 'color 0.2s ease',
          }}
          onMouseEnter={(e) => e.currentTarget.style.color = '#87A96B'}
          onMouseLeave={(e) => e.currentTarget.style.color = '#6B7B6E'}
        >
          Droits d'auteur
        </Link>
        <span style={{ color: '#D4D4C0' }}>•</span>
        <Link 
          to="/legal/legal-notice"
          style={{
            color: '#6B7B6E',
            textDecoration: 'none',
            transition: 'color 0.2s ease',
          }}
          onMouseEnter={(e) => e.currentTarget.style.color = '#87A96B'}
          onMouseLeave={(e) => e.currentTarget.style.color = '#6B7B6E'}
        >
          Mentions légales
        </Link>
      </div>

      {/* Quebec Symbol */}
      <div style={{
        opacity: 0.4,
        transition: 'opacity 0.3s ease'
      }}
      onMouseEnter={(e) => e.currentTarget.style.opacity = '0.7'}
      onMouseLeave={(e) => e.currentTarget.style.opacity = '0.4'}
      >
        <FleurDeLysIcon size={24} color="#87A96B" />
      </div>
    </div>
  );
};
